import React, { useState, useEffect } from 'react';
import {getDailyStatistics, setDailyStatistics} from "../../services/botService";

const DailyStats = () => {
    const [stats, setStats] = useState(null);
    const [targetInput, setTargetInput] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');

    useEffect(() => {
        const fetchStats = async () => {
            try {
                const data = await getDailyStatistics();
                setStats(data.data);
                setTargetInput(data.data.target);
            } catch (err) {
                console.error(err);
            }
        };
        fetchStats();
    }, []);

    const handleSetTarget = async () => {
        if (stats.canChangeTarget === false) {
            setMessage(stats.message || "Target cannot be changed today.");
            return;
        }

        setLoading(true);
        try {
            const result = await setDailyStatistics(Number(targetInput));
            if (result.success) {
                setStats(result.data);
                setMessage('Daily target updated successfully!');
            }
        } catch (err) {
            console.error(err);
            setMessage('Failed to update target.');
        } finally {
            setLoading(false);
        }
    };

    if (!stats) return <p className="text-center text-gray-400 p-4">Loading daily stats...</p>;

    const progressPercentage = Math.min(
        (stats.profit / stats.target) * 100,
        100
    );

    return (
        <div className="bg-gray-900 text-white p-4 sm:p-6 rounded-2xl shadow-lg mx-auto max-w-md w-full space-y-4 sm:space-y-6 border border-gray-700">
            <h2 className="text-xl sm:text-2xl font-bold text-center">Daily Statistics</h2>

            {/* Progress bar */}
            <div className="w-full bg-gray-800 rounded-full overflow-hidden h-4 sm:h-6">
                <div
                    className={`h-full transition-all duration-500 ${stats.profit >= 0 ? 'bg-green-500' : 'bg-red-500'}`}
                    style={{ width: `${Math.min(Math.abs(progressPercentage), 100)}%` }}
                />
            </div>
            
            <div className="text-center space-y-1">
                <p className="text-sm sm:text-base text-gray-300">
                    <span className="font-medium">Profit:</span> ${stats.profit.toFixed(2)} / 
                    <span className="font-medium"> Target:</span> ${stats.target.toFixed(2)}
                </p>
                <p className="text-sm text-gray-400">
                    {progressPercentage.toFixed(1)}% of target
                </p>
            </div>

            {/* Status */}
            <p className={`text-center font-medium text-sm sm:text-base ${stats.targetReached ? 'text-green-400' : 'text-yellow-400'}`}>
                {stats.targetReached ? '✅ Target reached!' : '⏳ Target not yet reached'}
            </p>

            {/* Input for target */}
            <div className="space-y-2 sm:space-y-0 sm:flex sm:space-x-2">
                <input
                    type="number"
                    min="1"
                    value={targetInput}
                    onChange={(e) => setTargetInput(e.target.value)}
                    disabled={!stats.canChangeTarget || loading}
                    className="w-full px-3 py-2 rounded-lg text-gray-900 dark:text-gray-900 text-sm sm:text-base"
                    placeholder="Set target amount"
                />
                <button
                    onClick={handleSetTarget}
                    disabled={!stats.canChangeTarget || loading}
                    className={`w-full sm:w-auto px-4 py-2 rounded-lg ${
                        !stats.canChangeTarget || loading 
                            ? 'bg-gray-600 cursor-not-allowed' 
                            : 'bg-blue-600 hover:bg-blue-700'
                    } text-white transition-colors whitespace-nowrap`}
                >
                    {loading ? 'Updating...' : 'Set Target'}
                </button>
            </div>

            {/* Message */}
            {message && (
                <p className="text-center text-sm sm:text-base py-2 px-3 rounded-lg bg-gray-800/50">
                    {message}
                </p>
            )}
        </div>
    );
};

export default DailyStats;
